<template>
  <div class="container-fluid px-3 px-md-5 py-5">
    <!-- Nagłówek strony -->
    <div class="text-center mb-5">
      <h1 class="display-4 fw-bold text-uppercase plan-title">Plan stanowisk</h1>
      <p class="lead text-muted fs-5">Zapoznaj się z układem naszego klubu i wybierz idealne miejsce dla siebie!</p>
      <div class="divider mx-auto my-3"></div>
    </div>

    <!-- Układ dwóch kolumn na szerokim ekranie: Plan i OMNI -->
    <div class="row g-4 mb-5">
      <!-- Sekcja z obrazkiem planu (Kolumna 1) -->
      <div class="col-xl-6">
        <div class="card shadow-lg border-0 plan-card overflow-hidden h-100 d-flex flex-column justify-content-between">
          <div class="card-body p-3 img-container text-center d-flex align-items-center justify-content-center flex-grow-1">
            <img
                src="../../assets/img/stands_v1.png"
                alt="Plan stanowisk Darts Bar"
                class="img-fluid rounded"
                style="max-height: 500px; object-fit: contain; width: 100%;"
            />
          </div>
          <div class="card-footer bg-body-tertiary border-top text-muted py-3 text-center">
            <small class="fs-6 text-body-secondary">
              <font-awesome-icon icon="fa-solid fa-info-circle" class="me-2 text-warning animate-pulse" />
              Powyższy schemat przedstawia poglądowe rozmieszczenie tarcz (stanowisk 1-5) w naszym lokalu.
            </small>
          </div>
        </div>
      </div>

      <!-- Sekcja OMNI Auto Scoring System (Kolumna 2) -->
      <div class="col-xl-6">
        <div class="row overflow-hidden rounded-3 omni-showcase-card shadow border align-items-stretch mx-0 h-100">
          <!-- Obrazek OMNI po lewej stronie - pełna wysokość, bez ramek -->
          <div class="col-md-5 col-lg-4 px-0 position-relative">
            <img
                src="../../assets/img/target_omni.png"
                alt="Target OMNI System"
                class="omni-full-height-img"
            />
          </div>
          <!-- Opis systemu OMNI po prawej stronie -->
          <div class="col-md-7 col-lg-8 p-4 p-lg-5 d-flex flex-column justify-content-center">
            <div>
              <span class="badge bg-danger mb-2 px-3 py-2 text-uppercase fw-bold fs-7 shadow-sm">
                <font-awesome-icon icon="fa-solid fa-bolt" class="me-1 animate-pulse" /> Nowoczesna Technologia
              </span>
              <h3 class="fw-bold mb-2 omni-title">OMNI Auto Scoring System</h3>
              <p class="mb-4 fs-6 omni-text-muted">
                Nasze stanowiska wyposażone są w rewolucyjny, automatyczny system zliczania punktów <strong>Target OMNI</strong>.
                Cztery inteligentne kamery HD rozmieszczone wokół tarczy śledzą każdy ruch rzutki w czasie rzeczywistym z bezkonkurencyjną dokładnością aż <strong>99.7%</strong>, przesyłając wyniki bezpośrednio na tablety oraz do popularnej aplikacji <strong>DartCounter</strong>. Graj bez konieczności ręcznego liczenia!
              </p>
              <div class="d-flex flex-wrap gap-2">
                <span class="badge bg-dark border border-secondary text-light px-3 py-2 fs-7">
                  <font-awesome-icon icon="fa-solid fa-video" class="me-2 text-info" /> 4 Kamery HD
                </span>
                <span class="badge bg-dark border border-secondary text-light px-3 py-2 fs-7">
                  <font-awesome-icon icon="fa-solid fa-star" class="me-2 text-warning" /> 99.7% Dokładności
                </span>
                <span class="badge bg-dark border border-secondary text-light px-3 py-2 fs-7">
                  <font-awesome-icon icon="fa-solid fa-mobile-alt" class="me-2 text-success" /> App DartCounter
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Szczegółowe informacje i sekcja rezerwacji -->
    <div class="row g-4 mt-2">
      <!-- Kolumna lewa - Opis stanowisk (Standardy) -->
      <div class="col-md-6">
        <div class="p-4 p-lg-5 border rounded-3 h-100 bg-body-tertiary shadow-sm">
          <h3 class="fw-bold mb-4 d-flex align-items-center">
            <font-awesome-icon icon="fa-solid fa-bullseye" class="text-danger me-3" />
            Nasze stanowiska
          </h3>
          <p class="text-body-secondary mb-4">
            Każde z naszych stanowisk do gry w darta zostało zaprojektowane z myślą o maksymalnym komforcie graczy. Dbamy o profesjonalne warunki, zarówno dla amatorów, jak i zaawansowanych graczy.
          </p>
          <div class="list-unstyled">
            <div class="mb-3 d-flex align-items-start feature-item">
              <font-awesome-icon icon="fa-solid fa-circle-check" class="text-success me-3 mt-1 fs-5" />
              <div>
                <strong class="text-body-emphasis">Profesjonalne oświetlenie LED</strong>
                <p class="text-muted small mb-0">Specjalne ringi świetlne eliminujące cienie na tarczy, zapewniające doskonałą widoczność każdego rzutu.</p>
              </div>
            </div>
            <div class="mb-3 d-flex align-items-start feature-item">
              <font-awesome-icon icon="fa-solid fa-circle-check" class="text-success me-3 mt-1 fs-5" />
              <div>
                <strong class="text-body-emphasis">Oficjalne turniejowe wymiary</strong>
                <p class="text-muted small mb-0">Wysokość tarczy (173 cm do środka) oraz odległość linii rzutu (237 cm) są precyzyjnie wymierzone.</p>
              </div>
            </div>
            <div class="mb-3 d-flex align-items-start feature-item">
              <font-awesome-icon icon="fa-solid fa-circle-check" class="text-success me-3 mt-1 fs-5" />
              <div>
                <strong class="text-body-emphasis">Komfortowa strefa kibica</strong>
                <p class="text-muted small mb-0">Przy każdym stanowisku znajduje się dedykowana loża z wygodnymi siedziskami dla Ciebie i Twoich znajomych.</p>
              </div>
            </div>
            <div class="mb-3 d-flex align-items-start feature-item">
              <font-awesome-icon icon="fa-solid fa-circle-check" class="text-success me-3 mt-1 fs-5" />
              <div>
                <strong class="text-body-emphasis">Szybki zapis wyników</strong>
                <p class="text-muted small mb-0">Wygodne tablety przy tarczach ułatwiające automatyczne i intuicyjne podliczanie punktów.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Kolumna prawa - Zachęta do rezerwacji -->
      <div class="col-md-6">
        <div class="p-4 p-lg-5 rounded-3 h-100 reservation-box text-white d-flex flex-column justify-content-between shadow-sm">
          <div>
            <h3 class="fw-bold mb-4 d-flex align-items-center text-warning">
              <font-awesome-icon icon="fa-solid fa-calendar-check" class="me-3" />
              Chcesz zagrać?
            </h3>
            <p class="text-white-50 mb-3 fs-5">
              Wybierz swoje ulubione stanowisko na planie i zarezerwuj je online już teraz!
            </p>
            <p class="text-white-50 mb-4">
              Gwarantujemy świetną zabawę, doskonałą sportową atmosferę oraz szeroki wybór chłodnych napojów i pysznych przekąsek w naszym barze.
            </p>
            <div class="alert alert-light border-0 bg-white bg-opacity-10 text-white mt-3 shadow-sm" role="alert">
              <div class="d-flex">
                <font-awesome-icon icon="fa-solid fa-exclamation-triangle" class="text-warning me-3 fs-4 align-self-center animate-bounce" />
                <div>
                  <strong class="text-white">Planujesz weekendową wizytę?</strong>
                  <p class="mb-0 small text-white-50">Zalecamy wcześniejszą rezerwację stanowisk online ze względu na bardzo duże zainteresowanie graczy.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-4 text-center">
            <router-link to="/rezerwacje" class="btn btn-reserve btn-lg w-100 py-3 text-uppercase shadow fs-5">
              <font-awesome-icon icon="fa-solid fa-bullseye" class="me-2 animate-spin-slow" /> Zarezerwuj stanowisko online
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SpacesPage",
}
</script>

<style scoped>
.container-fluid {
  width: 100%;
}

.plan-title {
  font-weight: 700;
  letter-spacing: 1px;
}

.divider {
  width: 80px;
  height: 4px;
  background-color: rgb(121, 19, 19);
  border-radius: 2px;
}

/* Plan Card styling */
.plan-card {
  border: 1px solid var(--bs-border-color);
  background-color: var(--bs-body-bg);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-radius: 12px;
}

.plan-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12) !important;
}

[data-bs-theme="dark"] .plan-card:hover {
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.5) !important;
}

.img-container {
  background-color: #1a1a1a;
  border-radius: 8px;
  overflow: hidden;
  padding: 15px;
}

[data-bs-theme="light"] .img-container {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

/* Omni Showcase Card & Light/Dark Mode Full Integration */
.omni-showcase-card {
  transition: transform 0.3s ease;
  border-radius: 12px;
}

.omni-showcase-card:hover {
  transform: translateY(-2px);
}

.omni-full-height-img {
  width: 100%;
  height: 100%;
  min-height: 250px;
  object-fit: cover;
  object-position: center;
  transition: transform 0.5s ease;
}

.omni-showcase-card:hover .omni-full-height-img {
  transform: scale(1.03);
}

[data-bs-theme="dark"] .omni-showcase-card {
  background: radial-gradient(circle at top left, #141b29 0%, #0c101b 100%);
  border-color: #202b3d !important;
}

[data-bs-theme="dark"] .omni-title {
  color: #ffffff;
}

[data-bs-theme="dark"] .omni-text-muted {
  color: rgba(255, 255, 255, 0.7) !important;
}

[data-bs-theme="light"] .omni-showcase-card {
  background: radial-gradient(circle at top left, #f8f9fa 0%, #e9ecef 100%);
  border-color: #dee2e6 !important;
}

[data-bs-theme="light"] .omni-title {
  color: #212529;
}

[data-bs-theme="light"] .omni-text-muted {
  color: #495057 !important;
}

/* Feature item styling */
.feature-item {
  transition: transform 0.2s ease, background-color 0.2s ease;
  padding: 12px;
  border-radius: 8px;
}
.feature-item:hover {
  transform: translateX(5px);
  background-color: var(--bs-secondary-bg);
}

/* Reservation box design */
.reservation-box {
  background: linear-gradient(135deg, #1c1c1c 0%, #2d2d2d 100%);
  border: 1px solid #3d3d3d;
  transition: transform 0.3s ease;
}

.reservation-box:hover {
  transform: translateY(-2px);
}

[data-bs-theme="light"] .reservation-box {
  background: linear-gradient(135deg, #791313 0%, #a82222 100%);
  border: 1px solid #630e0e;
  color: #fff !important;
}

[data-bs-theme="light"] .reservation-box h3 {
  color: #fdd835 !important;
}

[data-bs-theme="light"] .reservation-box .text-white-50 {
  color: rgba(255, 255, 255, 0.85) !important;
}

/* Buttons */
.btn-reserve {
  background: linear-gradient(135deg, #f0c040 0%, #c59824 100%);
  color: #000;
  border: none;
  font-weight: 700;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

.btn-reserve:hover {
  background: linear-gradient(135deg, #ffd966 0%, #f0c040 100%);
  box-shadow: 0 4px 15px rgba(240, 192, 64, 0.4);
  transform: translateY(-2px);
}

.animate-pulse {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
}

.animate-spin-slow {
  display: inline-block;
  animation: spin 8s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>